// extracted by mini-css-extract-plugin
export var subtitle = "CheckoutQuestions-module--subtitle--2vmi0";
export var checkoutSection = "CheckoutQuestions-module--checkoutSection--1Q-Uv";
export var label = "CheckoutQuestions-module--label--1iwVe";
export var textInput = "CheckoutQuestions-module--textInput--f_CqT";
export var errorField = "CheckoutQuestions-module--errorField--1qTwD";
export var sectionTitle = "CheckoutQuestions-module--sectionTitle--bzHUJ";
export var section = "CheckoutQuestions-module--section--2r9ol";
export var mainContactDetails = "CheckoutQuestions-module--mainContactDetails--3nfnO";